import UtmLink from '@/components/shared/UtmLink'

const ScrollToTopLink = ({ to, className, children, onClick, ...props }) => {
  const handleClick = e => {
    window.scrollTo(0, 0)
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <UtmLink to={to} className={className} onClick={handleClick} {...props}>
      {children}
    </UtmLink>
  )
}

export default ScrollToTopLink
